export default {
  "header": {
    "notification": {
      "tooltip": "Subscribe to notifications",
      "tooltip_active": "Unsubscribe to notifications"
    },
    "share": {
      "modal_title": "Share access to",
      "modal_subtitle": "Share with",
      "dialog_title": "Share {name}",
      "dialog_subtitle": "Members of the workspaces you turn on can open this dataset, read-only.",
      "empty": "There is no other workspace in this organization to share with.",
      "button": "Done",
      "tooltip": "Shared with {workspaces}"
    },
    "trigger": {
      "CRON": { "title": "Updated {readable} ({offset})", "subtitle": " Next run {next}", "tooltip": "Cron expression: {cron}" },
      "SCHEDULED": { "title": "Updated {readable} ({offset})", "subtitle": " Next run {next}", "tooltip": "Scheduled trigger" },
      "MANUAL": { "title": "This dataset does not update automatically", "tooltip": "Manual trigger" }
    }
  }
};
